"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _customradio_styles = _interopRequireDefault(require("./customradio_styles"));

var _customradio_definition = _interopRequireDefault(require("./customradio_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ CUSTOM RADIO ~~~~~~~~~~ ========== */


var Radio = (0, _reactJss.default)(_customradio_styles.default)(function (props) {
  var checkedState = props.checked ? props.checked : false;
  return _react.default.createElement("label", {
    className: "toggle radio customradio ".concat(props.classes.radio, " color-").concat(props.color ? props.color : 'primary')
  }, _react.default.createElement(_index.RadioField, {
    isList: props.isList,
    name: props.name,
    checked: props.checked,
    handleChange: props.handleChange,
    disabled: props.disabled,
    value: props.value
  }), _react.default.createElement("span", {
    className: "radiospan"
  }), " ", props.title ? _react.default.createElement("span", {
    className: 'text'
  }, props.title) : null);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Radio, _customradio_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Radio;
exports.default = _default;